export default "__VITE_ASSET__yCgpHnIW__"